import type { ArticleData } from '@wix/wix-help-widget-common/homepage';

import { HttpClientFactory } from '../../common/httpClient';
import { widgetSDK } from '../../sdk/widgetSDK';
import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';

const { clientTopology } = renderModel.get();

export const getRecommendedArticles = async (
  size: number,
  httpClient: HttpClientFactory,
): Promise<{ articles: ArticleData[]; modelId: string }> => {
  try {
    const context = await widgetSDK.getContext();
    const contextMappingUrl = context?.mappingUrl ?? '';
    const urlChunks = context.page.urlChunks;

    const queryParams = new URLSearchParams({
      size: String(size),
      contextMappingUrl,
      urlChunks: urlChunks.join(','),
    });

    fedopsLogger.interactionStarted('fetching-recommended-articles');

    const {
      data: { articles, modelId },
    } = await httpClient
      .getInstance()
      .get(`${clientTopology.widgetRecommendedArticlesUrl}?${queryParams.toString()}`);

    fedopsLogger.interactionEnded('fetching-recommended-articles');

    return { articles, modelId };
  } catch (error) {
    logger.error({
      message: 'failed to fetch recommended articles',
      error,
    });
    console.error(error);
    throw error;
  }
};
